import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { RelatedDocumentsComponent } from '../../../../shared-components/related-documents/related-documents.component';
import { DocumentSearchResult } from '../../../../document/models/documentSearchResult';
import { ChangecontrolPersistenceService } from '../../services/changecontrol-persistence.service';
import { LinkedDocument } from '../../../../shared/models/linked-documents';
import { ChangeControlLibraryConstants } from '../../constants/changeControlLibraryConstants';
import { ChangeControlAttachmentDetails } from '../../../../change-control/change-control-details/models/change-control-attachment-details';
import { ChangeControlDetails } from '../../models/change-control-details';
import { AssignmentGroupSharedDataService } from '../../../../../app/shared/services/assignment-group-shared-data.service';
import { ChangeControlPhase } from '../../enums/change-control-phases';
import { ChangeControlPersistenceService } from '../../../../../app/change-control/change-control-details/services/change-control-persistence.service';

@Component({
  selector: 'app-change-control-related-documents',
  templateUrl: './change-control-related-documents.component.html',
  styleUrls: ['./change-control-related-documents.component.scss']
})
export class ChangeControlRelatedDocumentsComponent implements OnInit{
  @Output() activateTabIndex = new EventEmitter<number>();
  errorMessages: string[] = [];
  isChangeControlSaveInProgress = false;
  changeControlSaveProgressMessage =
  ChangeControlLibraryConstants.ChangeControl_Save_InProgress;
  showRelatedDocumentsNotAlignedWithScopeConfirmationModal: boolean = false;
  documentScopeConfirmationMessage: string =
  ChangeControlLibraryConstants.RelatedDocuments_Not_Aligned_With_Scope_ConfirmationMessage;
  documentNumbersNotAlignedWithParentDocument: string[] = [];
  showDocumentLibrarySearch: boolean = false;
  linkedDocuments : LinkedDocument[]=[]
  deleteAttachmentConfirmationMessage: string =
  ChangeControlLibraryConstants.Deleted_Attachments_Confirmation_Message;
  deletedAttachments : ChangeControlAttachmentDetails[] = [];
  showDeletedFilesConfirmationModal : boolean = false;
  changeControlDetails !: ChangeControlDetails | null;
  InactiveAssignmentGroupField : any;
  inactiveGroupsSelected : any;
  isInActiveAssignmentGroupDialog:boolean = false;
  isReasonRequired:boolean=false;
isReasonForChangeControlUpdateRequired = false;
  reasonForChangeControlUpdate = '';
 heading: string = ChangeControlLibraryConstants.ReasonHeading;
  reasonValidationMessage: string = ChangeControlLibraryConstants.ReasonValidationMessage;

  changeControlRelatedDocuments : string = ChangeControlLibraryConstants.ChangeControlRelatedDocumentsTab
  @ViewChild(RelatedDocumentsComponent)

  private relatedDocumentsComponent!: RelatedDocumentsComponent;
  constructor(
    private changeControlPersistenceService: ChangecontrolPersistenceService, private assignmentGroupSharedDataService:AssignmentGroupSharedDataService,
 private  changecontrolPersistenceService:ChangeControlPersistenceService) { }

  ngOnInit(): void {
    this.changeControlPersistenceService.changeControlSaveInProgress$.subscribe(
    (changeControlSaveStatus) => {
      this.isChangeControlSaveInProgress = changeControlSaveStatus;
    }
  );
    this.changeControlPersistenceService.currentTabInSliderMenu$.subscribe(
      (tabIndex) => {
        if (tabIndex === ChangeControlLibraryConstants.ChangeControl_Menu_RelatedDocoument_Tab_Index) {
          this.updateRelatedDocumentsForSave();
        }
      }
    );
    this.changeControlPersistenceService.currentTabInSliderMenuByCustomChange$.subscribe(
      (tabIndex) => {
        if (tabIndex === ChangeControlLibraryConstants.ChangeControl_Menu_RelatedDocoument_Tab_Index) {
          this.showDocumentLibrarySearch = true;
          this.errorMessages = [];
          this.linkedDocuments = this.changeControlPersistenceService.linkedDocuments;
        }
      }
    );
    this.changeControlPersistenceService.closeAndResetChangeControlSlider$.subscribe(
      (isClose) => {
        if (isClose) {
          this.resetRelatedDocuments();
        }
      }
    );
  }

  addRelatedDocuments = () => {
    this.validateRelatedDocumentsLinking();
  }

  saveOrUpdateChangeControl = () => {
    this.updateRelatedDocumentsForSave();
    if (this.changeControlPersistenceService.isChangeControlEditSlider) {
      this.deletedAttachments = this.changeControlPersistenceService.deletedChangeControlAttachments;
      if (this.deletedAttachments.length > 0) {
        this.changeControlDetails = this.changeControlPersistenceService.changeManagementDetails$.getValue();
        this.showDeletedFilesConfirmationModal = true;
      }
      else{
        this.updateChangeManagement();
      }
    } else {
      this.changeControlPersistenceService.saveChangeManagement();
    }
  }

   updateChangeManagement() : void{
    if(this.changeControlDetails != null){
      this.changeControlPersistenceService.updateChangeManagementDetails(this.changeControlDetails);
    }
    this.inactiveGroupsSelected = undefined;
    this.inactiveGroupsSelected = this.assignmentGroupSharedDataService.findInactiveObjectsInValidatedList(this.changeControlPersistenceService.changeManagementDetails$.value,this.changeControlPersistenceService.validatedUsersList,
      this.changeControlPersistenceService.usersList
    );
    if(this.inactiveGroupsSelected != undefined && this.inactiveGroupsSelected.length > 0){
      this.isInActiveAssignmentGroupDialog = true;   
      this.InactiveAssignmentGroupField = this.inactiveGroupsSelected;
     }
     else{
      this.showDeletedFilesConfirmationModal= false;
      this.isReasonRequired= false;
        this.isReasonRequired = [
        ChangeControlPhase.Implementation,
        ChangeControlPhase.Verification,
        ChangeControlPhase.Complete].includes(this.changecontrolPersistenceService.currentPhaseOfChangeControl);

        if (this.isReasonRequired) {
          this.updateReasonForEditorSave();
        } 
        else{
            this.changeControlPersistenceService.updateChangeManagement();
        }


     }
  }

  updateReasonForEditorSave() {
    const phasesToCheck = [
      ChangeControlPhase.Implementation,
      ChangeControlPhase.Verification,
      ChangeControlPhase.Complete
    ];
  
    if (phasesToCheck.includes(this.changecontrolPersistenceService.currentPhaseOfChangeControl) && !this.reasonForChangeControlUpdate.length) {
      this.isReasonForChangeControlUpdateRequired = true;
    } else {
       this.changeControlPersistenceService.updateChangeManagement();
    }
  }
  
   closeReasonDailog(value: boolean) {
      this.isReasonForChangeControlUpdateRequired = value;
    }
  
    saveChangeControlwithReason(value: any) {
      this.reasonForChangeControlUpdate = value;
      this.isReasonForChangeControlUpdateRequired = false;
      this.changeControlPersistenceService.reasonForChangeControlUpdate=this.reasonForChangeControlUpdate;
       this.changeControlPersistenceService.updateChangeManagement();
    }

  closeConfirmationDailog(value : boolean){    
    this.isInActiveAssignmentGroupDialog = value
  }

  saveChangeControlwithInactiveUsers(){
    this.isInActiveAssignmentGroupDialog = false;
    this.isReasonRequired= false;
        this.isReasonRequired = [
        ChangeControlPhase.Implementation,
        ChangeControlPhase.Verification,
        ChangeControlPhase.Complete].includes(this.changecontrolPersistenceService.currentPhaseOfChangeControl);

        if (this.isReasonRequired) {
          this.updateReasonForEditorSave();
        } 
        else{
            this.changeControlPersistenceService.updateChangeManagement();
        }
  }

  openPreviousTab = () => {
    this.updateRelatedDocumentsForSave();
    this.activateTabIndex.emit(
      ChangeControlLibraryConstants.ChangeControl_Menu_File_Tab_Index
    );
    this.changeControlPersistenceService.onCustomTabChange(
      ChangeControlLibraryConstants.ChangeControl_Menu_File_Tab_Index
    );
  }

  updateRelatedDocumentsForSave = () => {
    if(this.relatedDocumentsComponent!=undefined)
      this.changeControlPersistenceService.updateRelatedDocuments(this.relatedDocumentsComponent.linkedDocuments);
  }

  validateRelatedDocumentsLinking = () => {
    this.errorMessages = [];
    if (this.changeControlPersistenceService.isChangeControlEditSlider) {
      this.validateSelfDocumentLinking();
    }
    this.validateIsDocumentLinked();
    if (this.errorMessages.length == 0) {
      this.validateeQMSScope();
    } else {
      document.querySelector('.p-tabview-panels')?.scrollTo(0, 0);
    }
  }

  validateSelfDocumentLinking = () => {
    let documentNumber =
      this.changeControlPersistenceService.changeManagementDetails$.value?.number || '';
    this.relatedDocumentsComponent.selectedDocuments.forEach((selectedDocument: DocumentSearchResult) => {
      if (selectedDocument.documentNumber === documentNumber) {
        this.errorMessages.push(ChangeControlLibraryConstants.RelatedDocuments_Self_Linking_ErrorMessage);
      }
    });
  }

  validateeQMSScope = () => {
    let changeControl =
      this.changeControlPersistenceService.changeManagementDetails$.value;
    let changeControleQMSScopeList = changeControl?.eQMSScopes || [];
    let selectedDocumentsWithoutSharedScope: string[] = [];
    let iseQMSScopeShared = false;
    this.relatedDocumentsComponent.selectedDocuments.forEach((document) => {
      iseQMSScopeShared = false;
      if (!!document.eQMSScope) {
        document.eQMSScope.forEach(eQMSScope => {
          if (changeControleQMSScopeList.filter(eqmsScopeData=>{
            return eqmsScopeData === eQMSScope;
          }).indexOf(eQMSScope) > -1
            && !iseQMSScopeShared) {
            iseQMSScopeShared = true;
          };
        });
        if (!iseQMSScopeShared) {
          selectedDocumentsWithoutSharedScope.push(document.documentNumber);
        }
      } else {
        selectedDocumentsWithoutSharedScope.push(document.documentNumber);
      }
    });
    if (selectedDocumentsWithoutSharedScope.length > 0) {
      this.documentNumbersNotAlignedWithParentDocument = selectedDocumentsWithoutSharedScope;
      this.relatedDocumentsComponent.showRelatedDocumentsNotAlignedWithScopeConfirmationModal = true;
    } else {
      this.relatedDocumentsComponent.updateRelatedDocumentList();
    }
  }
  validateIsDocumentLinked = () => {
    let relatedDocumentNumbers: string[] = this.relatedDocumentsComponent.linkedDocuments!= null? 
    this.relatedDocumentsComponent.linkedDocuments.map((document) => document.number) : [];
    let alreadyLinkedDocuments = this.relatedDocumentsComponent.selectedDocuments.filter(document => relatedDocumentNumbers.indexOf(document.documentNumber) !== -1);
    if (alreadyLinkedDocuments.length > 0) {
      let documentNumbers = alreadyLinkedDocuments.map((document) => document.documentNumber).join(", ");
      let errorMessageForAlreadyLinkedDocuments: string = alreadyLinkedDocuments.length === 1 ?
        ChangeControlLibraryConstants.RelatedDocuments_Already_Linked_With_Single_DocumentNumber_ErrorMessage.replace("Document_Number", documentNumbers) :
        ChangeControlLibraryConstants.RelatedDocuments_Already_Linked_With_Multi_DocumentNumbers_ErrorMessage.replace("Document_Numbers", documentNumbers)
      this.errorMessages.push(errorMessageForAlreadyLinkedDocuments);
    }
  }

  resetRelatedDocuments = () => {
    this.errorMessages = [];
    this.linkedDocuments = [];
    this.changeControlPersistenceService.linkedDocuments = [];
    this.showRelatedDocumentsNotAlignedWithScopeConfirmationModal = false;
  }


    closeConfirmationModal = () => {
      this.showDeletedFilesConfirmationModal = false;
    };
}
